import {
  Armchair,
  Bath,
  Bed,
  Box,
  Car,
  CookingPot,
  Lamp,
  Shirt,
  TreePine,
  Utensils,
  WashingMachine,
  type LucideIcon,
} from 'lucide-react';

/**
 * A room stores its icon as a lucide component name. Only these eleven are
 * offered: a free-text lucide name would let a record reference an icon that
 * isn't bundled, and the picker needs a finite set anyway.
 *
 * There is no room "type". The name is the user's and so is the icon — a
 * second, coarser label alongside them organised nothing.
 */
export const ICONS: Record<string, LucideIcon> = {
  Bed,
  Bath,
  CookingPot,
  Armchair,
  Utensils,
  Shirt,
  Lamp,
  WashingMachine,
  Car,
  TreePine,
  Box,
};

export const ICON_NAMES = Object.keys(ICONS);

/** What a new room starts with, until the user picks. */
export const DEFAULT_ICON = 'Armchair';

/** Falls back to Box rather than crashing if a record names an icon we dropped. */
export function iconByName(name: string): LucideIcon {
  return ICONS[name] ?? Box;
}
